import AdminAccessorial from './components/Accessorial/AdminAccessorial.vue'
import AdminBrandGroup from './components/BrandGroup/AdminBrandGroup.vue'
import AdminCalculation from './components/Calculation/AdminCalculation.vue'
import AdminConsolidationPoint from './components/ConsolidationPoint/AdminConsolidationPoint.vue'
import AdminCountry from './components/Country/AdminCountry.vue'
import AdminCurrency from './components/Currency/AdminCurrency.vue'
import AdminDataOption from './components/DataOption/AdminDataOption.vue'
import AdminDataOptionType from './components/DataOptionType/AdminDataOptionType.vue'
import AdminDocument from './components/Document/AdminDocument.vue'
import AdminExchangeRate from './components/ExchangeRate/AdminExchangeRate.vue'
import AdminExchangeRateHistory from './components/ExchangeRateHistory/AdminExchangeRateHistory.vue'
import AdminFinancialCode from './components/FinancialCode/AdminFinancialCode.vue'
import AdminFinancialProfile from './components/FinancialProfile/AdminFinancialProfile.vue'
import AdminJobType from './components/JobType/AdminJobType.vue'
import AdminJob from './components/Job/AdminJob.vue'
import AdminLocation from './components/Location/AdminLocation.vue'
import AdminQuoteTax from './components/QuoteTax/AdminQuoteTax.vue'
import AdminParty from './components/Party/AdminParty.vue'
import AdminPartyGroup from './components/PartyGroup/AdminPartyGroup.vue'
import AdminPointToPort from './components/PointToPort/AdminPointToPort.vue'
import AdminPortArea from './components/PortArea/AdminPortArea.vue'
import AdminReport from './components/Report/AdminReport.vue'
import AdminRequestForProposal from './components/RequestForProposal/AdminRequestForProposal.vue'
import AdminRole from './components/Role/AdminRole.vue'
import AdminRoutingRule from './components/RoutingRule/AdminRoutingRule.vue'
import AdminSpreadsheetDescriptor from './components/SpreadsheetDescriptor/AdminSpreadsheetDescriptor.vue'
import AdminTariff from './components/Tariff/AdminTariff.vue'
import AdminTransitMile from './components/TransitMile/AdminTransitMile.vue'
import AdminUserGroup from './components/UserGroup/AdminUserGroup.vue'
import AdminUser from './components/User/AdminUser.vue'
import AdminVendorZone from './components/VendorZone/AdminVendorZone.vue'

import Accessorial from './components/Accessorial/Accessorial.vue'
import BrandGroup from './components/BrandGroup/BrandGroup.vue'
import Calculation from './components/Calculation/Calculation.vue'
import ConsolidationPoint from './components/ConsolidationPoint/ConsolidationPoint.vue'
import Country from './components/Country/Country.vue'
import Currency from './components/Currency/Currency.vue'
import DataOption from './components/DataOption/DataOption.vue'
import DataOptionType from './components/DataOptionType/DataOptionType.vue'
import Document from './components/Document/Document.vue'
import ExchangeRate from './components/ExchangeRate/ExchangeRate.vue'
import ExchangeRateHistory from './components/ExchangeRateHistory/ExchangeRateHistory.vue'
import FinancialCode from './components/FinancialCode/FinancialCode.vue'
import FinancialProfile from './components/FinancialProfile/FinancialProfile.vue'
import JobType from './components/JobType/JobType.vue'
import Job from './components/Job/Job.vue'
import Location from './components/Location/Location.vue'
import Party from './components/Party/Party.vue'
import PartyGroup from './components/PartyGroup/PartyGroup.vue'
import PointToPort from './components/PointToPort/PointToPort.vue'
import PortArea from './components/PortArea/PortArea.vue'
import QuoteTax from './components/QuoteTax/QuoteTax.vue'
import Report from './components/Report/Report.vue'
import RequestForProposal from './components/RequestForProposal/RequestForProposal.vue'
import Role from './components/Role/Role.vue'
import RoutingRule from './components/RoutingRule/RoutingRule.vue'
import SpreadsheetDescriptor from './components/SpreadsheetDescriptor/SpreadsheetDescriptor.vue'
import TariffDescriptor from './components/SpreadsheetDescriptor/TariffDescriptor.vue'
import StaticDescriptor from './components/SpreadsheetDescriptor/StaticDescriptor.vue'
import NoteDescriptor from './components/SpreadsheetDescriptor/NoteDescriptor.vue'
import Tariff from './components/Tariff/Tariff.vue'
import TransitMile from './components/TransitMile/TransitMile.vue'
import UserGroup from './components/UserGroup/UserGroup.vue'
import User from './components/User/User.vue'
import VendorZone from './components/VendorZone/VendorZone.vue'

import AccessorialSearchResults from './components/Accessorial/AccessorialSearchResults.vue'
import BrandGroupSearchResults from './components/BrandGroup/BrandGroupSearchResults.vue'
import CalculationSearchResults from './components/Calculation/CalculationSearchResults.vue'
import ConsolidationPointSearchResults from './components/ConsolidationPoint/ConsolidationPointSearchResults.vue'
import CountrySearchResults from './components/Country/CountrySearchResults.vue'
import CurrencySearchResults from './components/Currency/CurrencySearchResults.vue'
import DataOptionSearchResults from './components/DataOption/DataOptionSearchResults.vue'
import DataOptionTypeSearchResults from './components/DataOptionType/DataOptionTypeSearchResults.vue'
import DocumentSearchResults from './components/Document/DocumentSearchResults.vue'
import ExchangeRateSearchResults from './components/ExchangeRate/ExchangeRateSearchResults.vue'
import ExchangeRateHistorySearchResults from './components/ExchangeRateHistory/ExchangeRateHistorySearchResults.vue'
import FinancialCodeSearchResults from './components/FinancialCode/FinancialCodeSearchResults.vue'
import FinancialProfileSearchResults from './components/FinancialProfile/FinancialProfileSearchResults.vue'
import JobTypeSearchResults from './components/JobType/JobTypeSearchResults.vue'
import JobSearchResults from './components/Job/JobSearchResults.vue'
import LocationSearchResults from './components/Location/LocationSearchResults.vue'
import PartySearchResults from './components/Party/PartySearchResults.vue'
import PartyGroupSearchResults from './components/PartyGroup/PartyGroupSearchResults.vue'
import PointToPortSearchResults from './components/PointToPort/PointToPortSearchResults.vue'
import PortAreaSearchResults from './components/PortArea/PortAreaSearchResults.vue'
import QuoteTaxSearchResults from './components/QuoteTax/QuoteTaxSearchResults.vue'
import ReportSearchResults from './components/Report/ReportSearchResults.vue'
import RequestForProposalSearchResults from './components/RequestForProposal/RequestForProposalSearchResults.vue'
import RoleSearchResults from './components/Role/RoleSearchResults.vue'
import RoutingRuleSearchResults from './components/RoutingRule/RoutingRuleSearchResults.vue'
import SpreadsheetDescriptorSearchResults from './components/SpreadsheetDescriptor/SpreadsheetDescriptorSearchResults.vue'
import TariffSearchResults from './components/Tariff/TariffSearchResults.vue'
import TransitMileSearchResults from './components/TransitMile/TransitMileSearchResults.vue'
import UserGroupSearchResults from './components/UserGroup/UserGroupSearchResults.vue'
import UserSearchResults from './components/User/UserSearchResults.vue'
import VendorZoneSearchResults from './components/VendorZone/VendorZoneSearchResults.vue'

import VZBuilder from './components/VendorZone/VZBuilder'

import store from '../../store'
import event from '../../event.js'
import { addCryptRouteId } from '../helpers/RouteHash'
import { handleNext } from '../helpers/RouteHelpers'

export default [
  {
    path: 'admin/accessorials',
    component: AdminAccessorial,
    children: [
      {
        path: '',
        component: Accessorial,
        name: 'Admin - Accessorials',
        meta: { description: 'Search, View, Edit and Add Accessorials' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const fc = store.dispatch('systemOption/loadFinancialCodes')
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, fc, serviceTypes], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Accessorial search',
        component: AccessorialSearchResults,
        meta: { description: 'Results for Accessorial Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Accessorial',
        component: Accessorial,
        meta: { description: 'Edit and/or View an Accessorial' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const fc = store.dispatch('systemOption/loadFinancialCodes')
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          const entity = store.dispatch('admin/getEntity', { entity: 'accessorial', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, entity, fc, serviceTypes], next)
        }
      }
    ]
  },
  {
    path: 'admin/brand-groups',
    component: AdminBrandGroup,
    children: [
      {
        path: '',
        component: BrandGroup,
        name: 'Admin - Tariff Set',
        meta: { description: 'Search, View, Edit and Add Tariff Set' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Tariff Set search',
        component: BrandGroupSearchResults,
        meta: { description: 'Results for Tariff Set Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Tariff Set',
        component: BrandGroup,
        meta: { description: 'Edit and/or View a Tariff Set' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'brand-group', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, entity], next)
        }
      }
    ]
  },
  {
    path: 'admin/calculations',
    component: AdminCalculation,
    children: [
      {
        path: '',
        name: 'Admin - Calculations',
        component: Calculation,
        meta: { description: 'Search, View, Edit and Add Calculations' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Calculation search',
        component: CalculationSearchResults,
        meta: { description: 'Results for Calculation Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Calculation',
        component: Calculation,
        meta: { description: 'Edit and/or View a Calculation' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'calculation', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO], next)
        }
      }
    ]
  },
  {
    path: 'admin/consolidation-points',
    component: AdminConsolidationPoint,
    children: [
      {
        path: '',
        component: ConsolidationPoint,
        name: 'Admin - Consolidation Points',
        meta: { description: 'Search, View, Edit and Add Consolidation Points' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Consolidation Point search',
        component: ConsolidationPointSearchResults,
        meta: { description: 'Results for Consolidation Point Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Consolidation Point',
        component: ConsolidationPoint,
        meta: { description: 'Edit and/or View a Consolidation Point' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'consolidation-point', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO], next)
        }
      }
    ]
  },
  {
    path: 'admin/countries',
    component: AdminCountry,
    children: [
      {
        path: '',
        component: Country,
        name: 'Admin - Countries',
        meta: { description: 'Search, View, Edit and Add Countries' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Country search',
        component: CountrySearchResults,
        meta: { description: 'Results for Country Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Country',
        component: Country,
        meta: { description: 'Edit and/or View a Calculation' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'country', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO], next)
        }
      }
    ]
  },
  {
    path: 'admin/currencies',
    component: AdminCurrency,
    children: [
      {
        path: '',
        component: Currency,
        name: 'Admin - Currencies',
        meta: { description: 'Search, View, Edit and Add Currencies' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Currency search',
        component: CurrencySearchResults,
        meta: { description: 'Results for Currency Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Currency',
        component: Currency,
        meta: { description: 'Edit and/or View a Currency' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'currency', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO], next)
        }
      }
    ]
  },
  {
    path: 'admin/data-options',
    component: AdminDataOption,
    children: [
      {
        path: '',
        component: DataOption,
        name: 'Admin - Data Options',
        meta: { description: 'Search, View, Edit and Add Data Options' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Data Option search',
        component: DataOptionSearchResults,
        meta: { description: 'Results for Data Option Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Data Option',
        component: DataOption,
        meta: { description: 'Edit and/or View a Data Option' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'data-option', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO], next)
        }
      }
    ]
  },
  {
    path: 'admin/data-option-types',
    component: AdminDataOptionType,
    children: [
      {
        path: '',
        component: DataOptionType,
        name: 'Admin - Data Option Types',
        meta: { description: 'Search, View, Edit and Add Data Option Types' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Data Option Type search',
        component: DataOptionTypeSearchResults,
        meta: { description: 'Results for Data Option Type Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Data Option Type',
        component: DataOptionType,
        meta: { description: 'Edit and/or View a Data Option Type' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      }
    ]
  },
  {
    path: 'admin/documents',
    component: AdminDocument,
    children: [
      {
        path: '',
        component: Document,
        name: 'Admin - Documents',
        meta: { description: 'Search, View, Edit and Add Documents' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Document search',
        component: DocumentSearchResults,
        meta: { description: 'Results for Document Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Document',
        component: Document,
        meta: { description: 'Edit and/or View a Document' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'document', id: addCryptRouteId(to.params.id) })
          handleNext([store.dispatch('systemOption/initialise'), entity], next)
        }
      }
    ]
  },
  {
    path: 'admin/reports',
    component: AdminReport,
    children: [
      {
        path: '',
        component: Report,
        name: 'Admin - Reports',
        meta: { description: 'Search, View, Edit and Add Reports' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Report search',
        component: ReportSearchResults,
        meta: { description: 'Results for Report Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Report',
        component: Report,
        meta: { description: 'Edit and/or View a Report' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'document', id: addCryptRouteId(to.params.id) })
          handleNext([store.dispatch('systemOption/initialise'), entity], next)
        }
      }
    ]
  },
  {
    path: 'admin/exchange-rates',
    component: AdminExchangeRate,
    children: [
      {
        path: '',
        component: ExchangeRate,
        name: 'Admin - Exchange Rates',
        meta: { description: 'Search, View, Edit and Add Exchange Rates' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Exchange Rate search',
        component: ExchangeRateSearchResults,
        meta: { description: 'Results for Exchange Rate Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Exchange Rate',
        component: ExchangeRate,
        meta: { description: 'Edit and/or View a Exchange Rate' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'exchange-rate', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO], next)
        }
      }
    ]
  },
  {
    path: 'admin/exchange-rate-histories',
    component: AdminExchangeRateHistory,
    children: [
      {
        path: '',
        component: ExchangeRateHistory,
        name: 'Admin - Exchange Rate Histories',
        meta: { description: 'Search, View, Edit and Add Exchange Rate Histories' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          const ex = store.dispatch('systemOption/loadExchangeRates')
          handleNext([dO, ex], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Exchange Rate History search',
        component: ExchangeRateHistorySearchResults,
        meta: { description: 'Results for Exchange Rate History Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          const ex = store.dispatch('systemOption/loadExchangeRates')
          handleNext([dO, ex], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Exchange Rate History',
        component: ExchangeRateHistory,
        meta: { description: 'Edit and/or View a Exchange Rate History' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          const ex = store.dispatch('systemOption/loadExchangeRates')
          handleNext([ex, dO], next)
        }
      }
    ]
  },
  {
    path: 'admin/financial-codes',
    component: AdminFinancialCode,
    children: [
      {
        path: '',
        component: FinancialCode,
        name: 'Admin - Financial Codes',
        meta: { description: 'Search, View, Edit and Add Financial Codes' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Financial Code search',
        component: FinancialCodeSearchResults,
        meta: { description: 'Results for Financial Code Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Financial Code',
        component: FinancialCode,
        meta: { description: 'Edit and/or View a Financial Code' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'financial-code', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO], next)
        }
      }
    ]
  },
  {
    path: 'admin/financial-profile',
    component: AdminFinancialProfile,
    children: [
      {
        path: '',
        component: FinancialProfile,
        name: 'Admin - Financial Profiles',
        meta: { description: 'Search, View, Edit and Add Financial Profiles' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Financial Profile search',
        component: FinancialProfileSearchResults,
        meta: { description: 'Results for Financial Profile Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Financial Profiles',
        component: FinancialProfile,
        meta: { description: 'Edit and/or View a Financial Profile' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          const fc = store.dispatch('systemOption/loadFinancialCodes')
          const calc = store.dispatch('systemOption/loadCalculations')
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          const entity = store.dispatch('admin/getEntity', { entity: 'financial-profile', id: addCryptRouteId(to.params.id) })
          handleNext([entity, dO, fc, calc, serviceTypes], next)
        }
      }
    ]
  },
  {
    path: 'admin/job-types',
    component: AdminJobType,
    children: [
      {
        path: '',
        component: JobType,
        name: 'Admin - Job Types',
        meta: { description: 'Search, View, Edit and Add Job Types' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Job Type search',
        component: JobTypeSearchResults,
        meta: { description: 'Results for Job Type Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Job Type',
        component: JobType,
        meta: { description: 'Edit and/or View a Job Type' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'job-type', id: addCryptRouteId(to.params.id) })
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO, serviceTypes], next)
        }
      }
    ]
  },
  {
    path: 'admin/jobs',
    component: AdminJob,
    children: [
      {
        path: 'search',
        name: 'Admin - Job search',
        component: JobSearchResults,
        meta: { description: 'Results for Job Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const jobTypes = store.dispatch('systemOption/loadJobTypes')
          handleNext([store.dispatch('systemOption/initialise'), jobTypes], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Job',
        component: Job,
        props: route => ({ id: addCryptRouteId(route.params.id) }),
        meta: { description: 'Edit and/or View a Job' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const jobTypes = store.dispatch('systemOption/loadJobTypes')
          handleNext([store.dispatch('systemOption/initialise'), jobTypes], next)
        }
      }
    ]
  },
  {
    path: 'admin/locations',
    component: AdminLocation,
    children: [
      {
        path: '',
        component: Location,
        name: 'Admin - Locations',
        meta: { description: 'Search, View, Edit and Add Locations' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const portAreas = store.dispatch('systemOption/loadPortAreas')
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, portAreas], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Location search',
        component: LocationSearchResults,
        meta: { description: 'Results for Location Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Location',
        component: Location,
        meta: { description: 'Edit and/or View a Location' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'location', id: addCryptRouteId(to.params.id) })
          const portAreas = store.dispatch('systemOption/loadPortAreas')
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO, portAreas], next)
        }
      }
    ]
  },
  {
    path: 'admin/parties',
    component: AdminParty,
    children: [
      {
        path: '',
        component: Party,
        name: 'Admin - Parties',
        meta: { description: 'Search, View, Edit and Add Parties' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const pg = store.dispatch('systemOption/loadPartyGroups')
          const dO = store.dispatch('systemOption/initialise')
          const charges = store.dispatch('systemOption/loadChargeProfiles')
          handleNext([dO, pg, charges], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Party search',
        component: PartySearchResults,
        meta: { description: 'Results for Party Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Party',
        component: Party,
        meta: { description: 'Edit and/or View a Party' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'party', id: addCryptRouteId(to.params.id) })
          const pg = store.dispatch('systemOption/loadPartyGroups')
          const dO = store.dispatch('systemOption/initialise')
          const charges = store.dispatch('systemOption/loadChargeProfiles')
          handleNext([entity, dO, pg, charges], next)
        }
      }
    ]
  },
  {
    path: 'admin/party-groups',
    component: AdminPartyGroup,
    children: [
      {
        path: '',
        component: PartyGroup,
        name: 'Admin - Party Groups',
        meta: { description: 'Search, View, Edit and Add Party Groups' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const pg = store.dispatch('systemOption/loadPartyGroups')
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, pg], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Party Group search',
        component: PartyGroupSearchResults,
        meta: { description: 'Results for Party Group Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Party Group',
        component: PartyGroup,
        meta: { description: 'Edit and/or View a Party Group' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'party-group', id: addCryptRouteId(to.params.id) })
          const pg = store.dispatch('systemOption/loadPartyGroups')
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO, pg], next)
        }
      }
    ]
  },
  {
    path: 'admin/point-to-ports',
    component: AdminPointToPort,
    children: [
      {
        path: '',
        component: PointToPort,
        name: 'Admin - Point To Ports',
        meta: { description: 'Search, View, Edit and Add Point To Ports' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Point To Port search',
        component: PointToPortSearchResults,
        meta: { description: 'Results for Point To Port Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Point To Port',
        component: PointToPort,
        meta: { description: 'Edit and/or View a Point To port' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const id = addCryptRouteId(to.params.id)
          const entity = store.dispatch('admin/getEntity', { entity: 'point-to-port', id: id })
          const pointToPortToPorts = store.dispatch('admin/getPointToPortToPorts', id)
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO, pointToPortToPorts], next)
        }
      }
    ]
  },
  {
    path: 'admin/port-areas',
    component: AdminPortArea,
    children: [
      {
        path: '',
        component: PortArea,
        name: 'Admin - Port Areas',
        meta: { description: 'Search, View, Edit and Add Port Areas' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Port Area search',
        component: PortAreaSearchResults,
        meta: { description: 'Results for Port Area Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Port Area',
        component: PortArea,
        meta: { description: 'Edit and/or View a Port Area' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const id = addCryptRouteId(to.params.id)
          const entity = store.dispatch('admin/getEntity', { entity: 'port-area', id: id })
          const portAreaToPorts = store.dispatch('admin/getPortAreaToPorts', id)
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO, portAreaToPorts], next)
        }
      }
    ]
  },
  {
    path: 'admin/quote-taxes',
    component: AdminQuoteTax,
    children: [
      {
        path: '',
        component: QuoteTax,
        name: 'Admin - Quote Taxes',
        meta: { description: 'Search, View, Edit and Add Quote Taxes' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Quote Tax search',
        component: QuoteTaxSearchResults,
        meta: { description: 'Results for Quote Tax Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Quote Tax',
        component: QuoteTax,
        meta: { description: 'Edit and/or View a Quote Tax' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'quote-tax', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, entity], next)
        }
      }
    ]
  },
  {
    path: 'admin/request-for-proposals',
    component: AdminRequestForProposal,
    children: [
      {
        path: '',
        component: RequestForProposal,
        name: 'Admin - Request For Proposals',
        meta: { description: 'Search, View, Edit and Add Request For Proposals' }
      },
      {
        path: 'search',
        name: 'Admin - Request For Proposal search',
        component: RequestForProposalSearchResults,
        meta: { description: 'Results for Request For Proposal Search' }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Request For Proposals',
        component: RequestForProposal,
        meta: { description: 'Edit and/or View a Request For Proposal' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'request-for-proposal', id: addCryptRouteId(to.params.id) })
          handleNext([entity], next)
        }
      }
    ]
  },
  {
    path: 'admin/roles',
    component: AdminRole,
    children: [
      {
        path: '',
        component: Role,
        name: 'Admin - Roles',
        meta: { description: 'Search, View, Edit and Add Roles' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const roles = store.dispatch('systemOption/loadRoles')
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, roles], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Role search',
        component: RoleSearchResults,
        meta: { description: 'Results for Role Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Role',
        component: Role,
        meta: { description: 'Edit and/or View a Role' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'role', id: addCryptRouteId(to.params.id) })
          const roles = store.dispatch('systemOption/loadRoles')
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO, roles], next)
        }
      }
    ]
  },
  {
    path: 'admin/routing-rules',
    component: AdminRoutingRule,
    children: [
      {
        path: '',
        component: RoutingRule,
        name: 'Admin - Routing Rules',
        meta: { description: 'Search, View, Edit and Add Routing Rules' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          handleNext([dO, serviceTypes], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Routing Rule search',
        component: RoutingRuleSearchResults,
        meta: { description: 'Results for Routing Rule Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Routing Rule',
        component: RoutingRule,
        meta: { description: 'Edit and/or View a Routing Rule' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'routing-rules', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          handleNext([entity, dO, serviceTypes], next)
        }
      }
    ]
  },
  {
    path: 'admin/spreadsheet-descriptors',
    component: AdminSpreadsheetDescriptor,
    children: [
      {
        path: '',
        component: SpreadsheetDescriptor,
        name: 'Admin - Spreadsheet Descriptors',
        meta: { description: 'Search, View, Edit and Add Spreadsheet Descriptors' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          const descriptorProperties = store.dispatch('systemOption/loadSpreadsheetDescriptorProperties')
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          handleNext([dO, descriptorProperties, serviceTypes], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Spreadsheet Descriptor search',
        component: SpreadsheetDescriptorSearchResults,
        meta: { description: 'Results for Spreadsheet Descriptor Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'tariff/:id/new',
        name: 'Admin - Add Spreadsheet Tariff Descriptor',
        component: TariffDescriptor,
        meta: { description: 'Add a new a Tariff Descriptor' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/setDescriptorParent', addCryptRouteId(to.params.id))
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, entity], next)
        }
      },
      {
        path: 'static/:id/new',
        name: 'Admin - Add Spreadsheet Static Descriptor',
        component: StaticDescriptor,
        meta: { description: 'Add a new a Static Descriptor' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/setDescriptorParent', addCryptRouteId(to.params.id))
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, entity], next)
        }
      },
      {
        path: 'note/:id/new',
        name: 'Admin - Add Spreadsheet Note Descriptor',
        component: NoteDescriptor,
        meta: { description: 'Add a new a Note Descriptor' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/setDescriptorParent', addCryptRouteId(to.params.id))
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, entity], next)
        }
      },
      {
        path: 'tariff/:id',
        name: 'Admin - Edit/View Spreadsheet Tariff Descriptor',
        component: TariffDescriptor,
        meta: { description: 'Edit and/or View a Tariff Descriptor' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'spreadsheet-descriptor', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO], next)
        }
      },
      {
        path: 'static/:id',
        name: 'Admin - Edit/View Spreadsheet Static Descriptor',
        component: StaticDescriptor,
        meta: { description: 'Edit and/or View a Static Descriptor' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'spreadsheet-descriptor', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          const fc = store.dispatch('systemOption/loadFinancialCodes')
          handleNext([entity, dO, fc], next)
        }
      },
      {
        path: 'note/:id',
        name: 'Admin - Edit/View Spreadsheet Note Descriptor',
        component: NoteDescriptor,
        meta: { description: 'Edit and/or View a Note Descriptor' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'spreadsheet-descriptor', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([entity, dO], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Spreadsheet Descriptor',
        component: SpreadsheetDescriptor,
        meta: { description: 'Edit and/or View a Spreadsheet Descriptor' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'spreadsheet-descriptor', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          const descriptorProperties = store.dispatch('systemOption/loadSpreadsheetDescriptorProperties')
          handleNext([entity, dO, descriptorProperties], next)
        }
      }
    ]
  },
  {
    path: 'admin/tariffs',
    component: AdminTariff,
    children: [
      {
        path: '',
        component: Tariff,
        name: 'Admin - Tariffs',
        meta: { description: 'Search, View, Edit and Add Tariffs' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          const pg = store.dispatch('systemOption/loadPartyGroups')
          const dO = store.dispatch('systemOption/initialise')
          const fc = store.dispatch('systemOption/loadFinancialCodes')
          handleNext([dO, serviceTypes, pg, fc], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Tariff search',
        component: TariffSearchResults,
        meta: { description: 'Results for Tariff Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          const fc = store.dispatch('systemOption/loadFinancialCodes')
          handleNext([dO, fc], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Tariff',
        component: Tariff,
        meta: { description: 'Edit and/or View a Tariff' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          const entity = store.dispatch('admin/getEntity', { entity: 'lookup', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          const pg = store.dispatch('systemOption/loadPartyGroups')
          const fc = store.dispatch('systemOption/loadFinancialCodes')
          handleNext([dO, entity, serviceTypes, pg, fc], next)
        }
      }
    ]
  },
  {
    path: 'admin/transit-miles',
    component: AdminTransitMile,
    children: [
      {
        path: '',
        component: TransitMile,
        name: 'Admin - Transit Miles',
        meta: { description: 'Search, View, Edit and Add Transit Miles' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Transit Mile search',
        component: TransitMileSearchResults,
        meta: { description: 'Results for Transit Mile Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Transit Mile',
        component: TransitMile,
        meta: { description: 'Edit and/or View a Transit Mile' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'transit-miles', id: addCryptRouteId(to.params.id) })
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, entity], next)
        }
      }
    ]
  },
  {
    path: 'admin/user-groups',
    component: AdminUserGroup,
    children: [
      {
        path: '',
        component: UserGroup,
        name: 'Admin - User Groups',
        meta: { description: 'Search, View, Edit and Add User Groups' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const ug = store.dispatch('systemOption/loadUserGroups')
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, ug], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - User Group search',
        component: UserGroupSearchResults,
        meta: { description: 'Results for User Group Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View User Group',
        component: UserGroup,
        meta: { description: 'Edit and/or View a User Group' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'user-group', id: addCryptRouteId(to.params.id) })
          const ug = store.dispatch('systemOption/loadUserGroups')
          const dO = store.dispatch('systemOption/initialise')
          const pg = store.dispatch('systemOption/loadPartyGroups')
          handleNext([dO, entity, ug, pg], next)
        }
      }
    ]
  },
  {
    path: 'admin/users',
    component: AdminUser,
    children: [
      {
        path: '',
        component: User,
        name: 'Admin - Users',
        meta: { description: 'Search, View, Edit and Add Users' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const u = store.dispatch('systemOption/loadUserGroups')
          const dO = store.dispatch('systemOption/initialise')
          const roles = store.dispatch('systemOption/loadRoles')
          const brandGroups = store.dispatch('systemOption/loadBrandGroups')
          handleNext([dO, u, roles, brandGroups], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - User search',
        component: UserSearchResults,
        meta: { description: 'Results for User Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View User',
        component: User,
        meta: { description: 'Edit and/or View a User' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const entity = store.dispatch('admin/getEntity', { entity: 'mai-user', id: addCryptRouteId(to.params.id) })
          const u = store.dispatch('systemOption/loadUserGroups')
          const dO = store.dispatch('systemOption/initialise')
          const roles = store.dispatch('systemOption/loadRoles')
          const brandGroups = store.dispatch('systemOption/loadBrandGroups')
          handleNext([dO, entity, u, roles, brandGroups], next)
        }
      }
    ]
  },
  {
    path: 'admin/vendor-zones',
    component: AdminVendorZone,
    children: [
      {
        path: '',
        component: VendorZone,
        name: 'Admin - Vendor Zones',
        meta: { description: 'Search, View, Edit and Add Vendor Zones' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO], next)
        }
      },
      {
        path: 'search',
        name: 'Admin - Vendor Zone search',
        component: VendorZoneSearchResults,
        meta: { description: 'Results for Vendor Zone Search' },
        beforeEnter: (to, from, next) => {
          handleNext([store.dispatch('systemOption/initialise')], next)
        }
      },
      {
        path: 'build/:id',
        name: 'Admin - Vendor Zone Builder',
        component: VZBuilder,
        meta: { description: 'Results for Vendor Zone Search' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const id = addCryptRouteId(to.params.id)
          const dO = store.dispatch('systemOption/initialise')
          const entity = store.dispatch('admin/getEntity', { entity: 'vendor-zone', id: id })
          handleNext([dO, entity], next)
        }
      },
      {
        path: ':id',
        name: 'Admin - Edit/View Vendor Zone',
        component: VendorZone,
        meta: { description: 'Edit and/or View a Vendor Zone' },
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const id = addCryptRouteId(to.params.id)
          const dO = store.dispatch('systemOption/initialise')
          const entity = store.dispatch('admin/getEntity', { entity: 'vendor-zone', id: id })
          const vendorZoneLocations = store.dispatch('admin/getVendorZoneLocations', id)
          const vendorZoneLocationsCount = store.dispatch('admin/getVendorZoneLocationsCount', id)
          handleNext([dO, entity, vendorZoneLocations, vendorZoneLocationsCount], next)
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/admin/routes.js